import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "inverse"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TextSmall } from '../typography';

var SuccessText = /*#__PURE__*/function (_PureComponent) {
  _inherits(SuccessText, _PureComponent);

  var _super = _createSuper(SuccessText);

  function SuccessText() {
    _classCallCheck(this, SuccessText);

    return _super.apply(this, arguments);
  }

  _createClass(SuccessText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          inverse = _this$props.inverse,
          others = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(TextSmall, _extends({
        color: "mint",
        "data-teamleader-ui": "success-text",
        marginTop: 1,
        tint: inverse ? 'light' : 'dark'
      }, others), children);
    }
  }]);

  return SuccessText;
}(PureComponent);

export { SuccessText as default };
SuccessText.defaultProps = {
  children: 'This is the success text',
  inverse: false
};